
jQuery(document).ready(function($) {
    $(function () {
        let top_show = 280, speed = 500, $backButton = $('#up');
        $(window).scroll(function () {
            if ($(this).scrollTop() > top_show) {
                $backButton.addClass('active');
            } else {
                $backButton.removeClass('active');
            }
        });
        $backButton.click(function () {
            scrollto(0, speed);
        });

        // scrollto
        window.scrollto = function (destination, speed) {
            if (typeof speed == 'undefined') {
                speed = 800;
            }
            jQuery("html:not(:animated),body:not(:animated)").animate({scrollTop: destination - 60}, speed);
        };
        $("a.scrollto").click(function () {
            var elementClick = $(this).attr("href")
            var destination = $(elementClick).offset().top;
            scrollto(destination);
            return false;
        });
        // end scrollto


        // fancybox
        $('.fancybox').fancybox({
            padding: 0,
            helpers: {
                overlay: {
                    locked: false
                }
            },
            lang: 'ru',
            i18n: {
                'ru': {
                    CLOSE: 'Закрыть',
                    NEXT: "Далее",
                    PREV: "Назад",
                    ERROR: "Запрошенные данные не могут быть загружены. <br/> Повторите попытку позже.",
                    PLAY_START: "Начать слайд-шоу",
                    PLAY_STOP: "Завершить слайд-шоу",
                    FULL_SCREEN: "На весь экран",
                    THUMBS: "Миниатюры",
                    DOWNLOAD: "Скачать",
                    SHARE: "Поделиться",
                    ZOOM: "Увеличить"
                }
            }
        });

        $('.fancyboxModal').fancybox({
            autoResize: true,
            padding: 0,
            fitToView: false,
            maxWidth: '100%',
            scrolling: "no",
            wrapCSS: 'fancybox-animate-wrap',
            touch: false,
            autoFocus: false,
            lang: 'ru',
            i18n: {
                'ru': {
                    CLOSE: 'Закрыть',
                    NEXT: "Далее",
                    PREV: "Назад",
                }
            }
        });

        $('.fancyboxvideo').fancybox({
            padding: 0,
            width: '1300px',
            height: '',
            maxWidth: '100%',
            maxHeight: '100%',
            helpers: {
                overlay: {
                    locked: false
                }
            },
            lang: 'ru',
            i18n: {
                'ru': {
                    CLOSE: 'Закрыть',
                    NEXT: "Далее",
                    PREV: "Назад",
                }
            }
        });
        // end fancybox


        // Carousels
        var $carousel = $('.cases-carousel');
        if ($carousel.length) {
            $carousel.slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                autoplaySpeed: 5000,
                speed: 800,
                arrows: true,
                prevArrow: '<a href="#" class="slick-prev"></a>',
                nextArrow: '<a href="#" class="slick-next"></a>',
                dots: false,
                swipe: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            swipe: true,
                        },
                    },
                ]
            });

        }
        $(".reviews-carousel").slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            //autoplay: true,
            swipeToSlide: true,
            autoplaySpeed: 4000,
            speed: 800,
            arrows: true,
            prevArrow: '<a href="#" class="slick-prev"></a>',
            nextArrow: '<a href="#" class="slick-next"></a>',
            dots: false,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });

        $('.gallery-carousel').slick({
            autoplay: true,
            lazyLoad: 'ondemand',
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplaySpeed: 5000,
            speed: 800,
            arrows: false,
            dots: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ]
        });
        // End Carousels


        let menuButton = $('.menu-button'), mobMenuWrap = $('.mobile-menu-wrapper');
        menuButton.click(function () {
            menuButton.toggleClass('active');
            mobMenuWrap.toggleClass('open');
        });
        $('.mobile-menu-wrapper, .menu-button').click(function (e) {
            if ($(e.target).hasClass('fancyboxModal') == false) {
                e.stopPropagation();
            }
        });

        $('.swipe-area, .overlay').swipe({
            swipeStatus: function (event, phase, direction, distance, duration, fingers) {
                if (phase == 'move' && direction == 'left') {
                    mobMenuWrap.addClass('open');
                    menuButton.addClass('active');
                    return false;
                }
                if (phase == 'move' && direction == 'right') {
                    mobMenuWrap.removeClass('open');
                    menuButton.removeClass('active');
                    return false;
                }
            }
        });

        $('body').click(function () {
            mobMenuWrap.removeClass('open');
            menuButton.removeClass('active');
        });


        $('.mobile-menu ul > li').has('ul').addClass('down');
        $('.mobile-menu .down > ul').before('<span class="dropdown-button"></span>');


        $('.mobile-menu .dropdown-button').click(function () {
            $(this).toggleClass('active');
            if ($(this).siblings('ul').is(':visible')) {
                $(this).siblings('ul').slideUp();
            } else {
                $(this).siblings('ul').slideDown();
            }

        });


        $('.header-search-btn').click(function () {
            $('.search-form-section').addClass('active');
            $('.search-input').focus();
            $('body').addClass('overflow-block');
        });

        $('.search-close, .search-form-block-overlay').click(function () {
            $('.search-form-section').removeClass('active');
            $('body').removeClass('overflow-block');
        });


        $('.header-contacts-title-overlay').click(function () {
            $('.header-contacts-dropdown').toggle();
        });


        $(document).mouseup(function (e) {
            let windW = window.innerWidth;
            if (windW < 992) {
                let div = $(".header-contacts-dropdown"); // тут указываем ID элемента
                if (!div.is(e.target) // если клик был не по нашему блоку
                    && div.has(e.target).length === 0) { // и не по его дочерним элементам
                    div.hide(); // скрываем его
                }
            }
        });

        $('.header-contacts-dropdown-close').click(function () {
            $('.header-contacts-dropdown').hide();
        });


        // tabs
        $('ul.tabs li:first-of-type').addClass('current');
        $('.boxes > div:first-of-type').addClass('visible');
        $('.mobile-tab-header').text($('ul.tabs li:first-of-type').text());

        $('ul.tabs').on('click', 'li:not(.current)', function () {

            $(this)
                .addClass('current').siblings().removeClass('current')
                .closest('.tabs-section').closestChild('div.box').removeClass('visible').eq($(this).index()).addClass('visible');
        });

        $('ul.tabs.mobile li').click(function () {
            $(this).parent().hide().siblings('.mobile-tab-header').html($(this).html());
            $('.mobile-tab-header').removeClass('active');
        });
        $('.mobile-tab-header').click(function (e) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).siblings('.tabs.mobile').stop().slideUp(0);
            } else {
                $(this).addClass('active');
                $(this).siblings('.tabs.mobile').stop().slideDown(0);
            }

            e.stopPropagation();
        });
        // end tabs


        // accordion
        let $thisElement,
            $thisElementContent,
            $elements,
            $elementsContent;

        $('.accordion .item-head').click(function () {
            $thisElement = $(this).parent();
            $thisElementContent = $thisElement.find('.item-body');
            $elements = $thisElement.siblings();
            $elementsContent = $elements.find('.item-body');

            $elements.removeClass('active');
            $elementsContent.slideUp();
            if (!$thisElement.hasClass('active')) {
                $thisElement.addClass('active');
                $thisElementContent.slideDown();
            } else {
                $thisElement.removeClass('active');
                $thisElementContent.slideUp();
            }

        });

        $('.accordion .item:first-child .item-head').trigger('click');

        // end accordion

        $('a[href="#feedback"]').click(function () {
            let theme = $(this).data('theme'),
                title = $(this).data('title');

            $('#feedback_theme').val(theme);
            $('#feedback_title').text(title);
        });


        $('.footer .item-title-btn').click(function () {
            if (!$(this).parents('.item').hasClass('active')) {
                $(this).parents('.item').addClass('active')
                $(this).parents('.item').find('.dropdown').slideDown();
            } else {
                $(this).parents('.item').removeClass('active');
                $(this).parents('.item').find('.dropdown').slideUp();
            }
        });


        $('.room-types label').click(function () {
            $('.rooms-number input').prop('checked', false);
        });

        $('.rooms-number label').click(function () {
            $('.room-types input').prop('checked', false);
        });


        // FIXED HEADER PANEL AT THE SCROLL
        let header_main_height = $('.header-main').height();

        let header_main_inner_height = $('.header-main-inner').height();
        $('.header-main-wrapper-push').height(header_main_inner_height);


        let h_hght = header_main_height + 250,
            h_mrg = 0,
            elem = $('.header-main-wrapper'),
            top = $(this).scrollTop();


        if (top > header_main_height) {
            elem.addClass('pred_fixed');
        }

        if (top > h_hght) {
            elem.addClass('fixed');
        }

        $(window).scroll(function () {
            top = $(this).scrollTop();

            if (top + h_mrg < header_main_height) {
                elem.removeClass('pred_fixed');
            } else {
                elem.addClass('pred_fixed');
            }

            if (top + h_mrg < h_hght) {
                elem.removeClass('fixed');
            } else {
                elem.addClass('fixed');
            }
        });

        // /. FIXED HEADER PANEL AT THE SCROLL


    }); // end ready


    window.onload = function () {
        let top_menu_w,
            top_menu_first_ul_w,
            candidate_li_w,
            coming_ul_w,
            $top_menu_li,
            this_top_menu_li_w,
            total_top_menu_li_w = 0,
            $top_menu_more_list = $('.top-menu-more-list'),
            $top_menu_more_list_sublist = $('.top-menu-more-list-sublist'),
            windWidth = window.innerWidth;

        function topMenuWidthComparison() {
            top_menu_w = $('.top-menu').width() - 50;
            total_top_menu_li_w = 0;
            $('.top-menu > ul:first-of-type > li').each(function () {
                $top_menu_li = $(this);
                this_top_menu_li_w = $top_menu_li.width();
                $top_menu_li.attr('data-realwidth', this_top_menu_li_w);
                total_top_menu_li_w += this_top_menu_li_w;
            });
            if (total_top_menu_li_w > top_menu_w) {
                if (!$top_menu_more_list.hasClass('active')) {
                    $top_menu_more_list.addClass('active');
                }
                $('.top-menu > ul:first-of-type > li:last-of-type').prependTo($top_menu_more_list_sublist).addClass('transferred');
            }
        }

        function topmenumorelink() {
            do {
                topMenuWidthComparison()
            } while (total_top_menu_li_w > top_menu_w);

            if (!$('.top-menu').hasClass('loaded')) {
                $('.top-menu').addClass('loaded');
            }
        }

        function topmenumorelinkReverse() {
            top_menu_w = $('.top-menu').width() - 50;
            top_menu_first_ul_w = $('.top-menu > ul').width();
            candidate_li_w = $('.top-menu-more-list-sublist .transferred:first').data('realwidth');
            coming_ul_w = top_menu_first_ul_w + candidate_li_w;
            if (coming_ul_w < top_menu_w) {
                $('.top-menu-more-list-sublist .transferred:first').appendTo('.top-menu > ul:first-of-type');
            }
            if ($('.top-menu-more-list-sublist .transferred').length < 1) {
                $top_menu_more_list.removeClass('active');
            }
        }

        if (windWidth > 991) {
            topmenumorelink();
        }

        window.addEventListener("resize", function () {
            windWidth = window.innerWidth;
            if (windWidth > 991) {
                topmenumorelink();
                topmenumorelinkReverse();
            }

        }, false);

        window.addEventListener("orientationchange", function () {
            windWidth = window.innerWidth;
            if (windWidth > 991) {
                topmenumorelink();
                topmenumorelinkReverse();
            }
        }, false);

    };

    $(function () {
        $('.case-slider-wrapper').each(function () {
            const $wrapper = $(this);
            const $slider = $wrapper.find('.case-slider');
            const $thumbnails = $wrapper.find('.case-slider-thumbnails');

            // Ищем уникальный класс типа case-slider-1
            const sliderClass = '.' + $slider.attr('class').split(/\s+/).find(cls => cls.startsWith('case-slider-') && cls !== 'case-slider');
            const thumbsClass = '.' + $thumbnails.attr('class').split(/\s+/).find(cls => cls.startsWith('case-slider-thumbnails-') && cls !== 'case-slider-thumbnails');

            initSlickSliders(sliderClass, thumbsClass);
        });

        function initSlickSliders(caseSliderClass, caseSliderThumbnailsClass) {
            $(caseSliderClass).slick({
                fade: true,
                autoplaySpeed: 5000,
                speed: 800,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                infinite: true,
                swipe: false,
                asNavFor: caseSliderThumbnailsClass,
            });

            $(caseSliderThumbnailsClass).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: caseSliderClass,
                focusOnSelect: true,
                swipeToSlide: true,
                infinite: true,
                arrows: false,
                centerPadding: '0',
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4
                    },
                },
                    {
                        breakpoint: 768,
                        settings: {
                            swipe: false
                        },
                    }]
            });
        }
    });


});
